// Shared filter utilities

// Count active filters safely across the app
export function getActiveFilterCount(filters = {}) {
  let count = 0;
  if (Array.isArray(filters.categories) && filters.categories.length) count += filters.categories.length;
  if (Array.isArray(filters.cities) && filters.cities.length) count += filters.cities.length;
  if (Array.isArray(filters.businessTypes) && filters.businessTypes.length) count += filters.businessTypes.length;
  // Count verified when explicitly set to a value (string 'true'|'false' or boolean)
  if (typeof filters.verified !== 'undefined' && filters.verified !== '') count += 1;
  return count;
}

// Normalize verified value to 'true' | 'false' | undefined
export function normalizeVerified(value) {
  if (value === true || value === 'true') return 'true';
  if (value === false || value === 'false') return 'false';
  return undefined;
}

